import { useEffect, useRef } from "react";

import { useHttp } from "../../providers/http";
import { useDashboard } from '../../providers/dashboard';
import Dropdown from "./dropdown";
import CarInfo from "./car-info";
import Selector from "./selector";
import dayjs from "dayjs";
import Detail from "./detail";
import DashboardNav from "../../components/nav/dashboard-nav";
import Modal from "./modal";
import { useAuth } from "../../providers/auth";

//https://rest.skorstensgaard.dk/api/cars/173384/history

const mapping = {
    "creditmemo": 1,
    "invoice": 2,
    "order": 3,
    "offer": 4
}

const DashboardScreen = () => {
    const { state, dispatch } = useDashboard()
    const modalRef = useRef();
    const http = useHttp();
    const { state: authState, dispatch: authDispatch, setToken } = useAuth();

    useEffect(() => {
        if (state.cars) return;
        http.get("/cars")
            .then(({ data }) => {
                dispatch({
                    key: "cars",
                    value: data
                })
            })
    }, [state.cars, dispatch])

    useEffect(() => {
        if (!state.cars) return;
        http.get(`/cars/${state.cars[state.selectedCar].id}/history`)
            .then(({ data }) => {
                dispatch({
                    key: "selectedCarHistory",
                    value: Object.entries(data).reduce((acc, [k, arr]) => {
                        return [
                            ...acc,
                            [
                                k,
                                arr.sort((a, b) => mapping[a.type] > mapping[b.type])
                            ]
                        ]
                    }, [])
                        .sort(([_, v], [__, i]) => dayjs(v[0].updated_at).isBefore(dayjs(i[0].updated_at)))
                })
            })
    }, [state.selectedCar, state.cars, dispatch])

    useEffect(() => {
        dispatch({
            key: "selectedDetail",
            value: null
        })
    }, [state.selectedCar])

    const fetchDetail = (type, id) => {
        if (state.selectedDetail?.id === id) {
            dispatch({
                key: "selectedDetail",
                value: null
            })
        } else {
            http.get(`/cars/${state.cars[state.selectedCar].id}/history/${type}/${id}`)
                .then(({ data }) => {
                    dispatch({
                        key: "selectedDetail",
                        value: data
                    })
                })
        }
    }

    if (!state.cars) return null;

    return (
        <div
            className="text-skgBlue bg-repair-pattern bg-cover min-h-screen max-h-screen font-supermolot overflow-y-hidden"
        >
            <DashboardNav
                logOut={
                    () => {
                        setToken(null)
                    }
                }
            />
            <div
                className="flex max-w-1400 mx-auto"
            >
                <div
                    className="basis-full lg:basis-3/4 overflow-y-scroll py-16 px-4 xl:px-0"
                    style={{
                        maxHeight: "calc(100vh - 56px)",
                        minHeight: "calc(100vh - 56px)"
                    }}
                >
                    <div
                        className="sm:w-96 mb-7"
                    >
                        <Dropdown />
                    </div>
                    <div
                        className="mb-4 lg:hidden sm:w-96"
                    >
                        <CarInfo />
                    </div>
                    <div
                        className="basis-full mb-7"
                    >
                        <p
                            className="text-2xl"
                            onClick={() => modalRef.current.test()}
                        >
                            Oversigt
                        </p>
                        <p
                            className="font-light"
                        >
                            Her finder du en oversigt over udstedte faktura, kreditnota samt tilbud
                        </p>
                        <hr
                            className="bg-skgRed h-2 w-52 mt-4"
                        />
                    </div>
                    <div
                        className="flex flex-wrap space-y-3 md:space-y-0"
                    >
                        <div
                            className="basis-full md:basis-1/4"
                        >
                            <Selector
                                fetchDetail={fetchDetail}
                            />
                        </div>
                        <div
                            className="basis-full md:basis-3/4 md:px-7"
                        >
                            {
                                modalRef.current && (
                                    <Detail
                                        openModal={modalRef.current.toggleModal}
                                    />
                                )
                            }
                        </div>
                    </div>
                </div>
                <div
                    className="basis-1/4 flex-col py-16 justify-between hidden lg:flex pr-4 xl-pr-0"
                >
                    <div
                        className="flex flex-col"
                    >
                        <CarInfo />
                        <a
                            className="bg-skgBlue py-5 text-lg px-5 text-white rounded-md text-start mt-5 relative overflow-hidden"
                            href="/booking"
                        >
                            <i
                                className="icon icon-percentage absolute text-7xl opacity-40 -left-3 top-0"
                            />
                            <span>
                                Book tid
                            </span>
                        </a>
                        <a
                            className="bg-skgRed py-5 text-lg px-5 text-white rounded-md text-start mt-5 relative overflow-hidden"
                            href="/faatilbud"
                        >
                            <i
                                className="icon icon-book-time absolute text-7xl opacity-40 -left-3 top-0"
                            />
                            <span>
                                Få tilbud
                            </span>
                        </a>
                    </div>
                    <div
                        className="bg-skgBlue border-l-8 border-skgRed rounded-md shadow-md text-white p-5 font-extralight text-lg space-y-4"
                    >
                        <p>
                            Har du spørgsmål, så ring til vores kundeservice
                        </p>
                        <p
                            className="font-bold"
                        >
                            7244 4424
                        </p>
                    </div>
                </div>
            </div>
            <Modal
                ref={modalRef}
            />
        </div>
    )
}

export default DashboardScreen;